import React, { useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import FatorBox from '../../components/FatorBox';
import { Checkbox } from 'antd';
interface Props {
  initValue: number[];
  changeFator: (fator: { type: number | undefined }) => void;
}

enum ProductStatusType {
  /** 普通商品 */
  Default = 1,
  /** 预售商品 */
  Prepaid,
}

const TypeItem: React.FC<Props> = ({ changeFator, initValue }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<number[]>([]);
  const saleOptions = useMemo(() => {
    return [
      { label: t('base.stock'), value: ProductStatusType.Default },
      { label: t('base.preOrder'), value: ProductStatusType.Prepaid },
    ];
  }, [t]);
  const changeType = (val: any[]) => {
    setValue(val);
    if (val) {
      if (val.length === 1) {
        changeFator({
          type: val[0],
        });
      } else {
        changeFator({
          type: undefined,
        });
      }
    }
  };
  const reload = () => {
    setValue([]);
    changeFator({
      type: undefined,
    });
  };
  useEffect(() => {
    if (initValue && initValue.length === 1) {
      setValue(initValue);
    }
  }, [initValue]);
  return (
    <FatorBox title={t('mall.status')} reload={reload}>
      <Checkbox.Group
        className="flex-column"
        options={saleOptions}
        onChange={changeType}
        defaultValue={initValue}
        value={value}
      />
    </FatorBox>
  );
};

export default TypeItem;
